import { stegaClean } from '@sanity/client/stega';

// Visual Editing (draft mode) wraps every string field with invisible stega
// characters so the overlay can map rendered text back to its source field.
// That's fine for prose that's only ever displayed, but breaks any string
// used as a lookup key, enum comparison, or passed to a strict-equality
// check (colorScheme, featureKey, category keys, icon names, status enums).
// Use this wherever a Sanity-sourced string drives logic rather than display.
export function cleanEnum<T extends string | undefined | null>(value: T): T {
  return value == null ? value : (stegaClean(value) as T);
}
